import {BaseService} from './base'
import {timeFormat} from "../utils";
import {RENEWAL_ORDER_STATUS, RENEWAL_TYPE} from "../config";
import {sexFilter} from "../filters";

class RenewalService extends BaseService {
  constructor() {
    super();
  }

  /**
   * 列表
   * @param replyStatus
   * @param pageNum
   * @param pageSize
   * @returns {Promise<*>}
   */
  async list({replyStatus, pageNum = 1, pageSize = 10}) {
    const {code, list, page} = await this.$http('smarthos.continuation.prescription.list', {
      replyStatus,
      pageNum,
      pageSize
    });
    if (code === '0') return {
      list: list.map(r => this.handlerItem(r)), page
    };
    return {list: [], page: {}};
  }

  /**
   * 详情
   * @param id
   * @param hosId
   * @param orgid
   * @returns {Promise<void>}
   */
  async info({id, hosId, orgid}) {
    const {code, obj} = await this.$http('smarthos.continuation.prescription.info', {id, orgid, hosId});
    return code === '0' ? this.handlerItem(obj) : {};
  }

  /**
   * 处方详细
   * @param chufangdh
   * @param orgid
   * @param hosId
   * @returns {Promise<void>}
   */
  async xfxx({chufangdh, orgid, hosId}) {
    //ApiAddRecipeService
    const {code, list} = await this.$http('smarthos.yygh.ApiAddRecipeService.paiedDetail', {chufangdh, orgid, hosId});
    return code === '0' ? list : [];
  }


  /**
   * 未支付处方列表
   * @param idcard
   * @param hosId
   * @param isXx
   * @returns {Promise<void>}
   */
  async unpaied({idcard, hosId, isXx = 0}) {
    const {code, list} = await this.$http('smarthos.yygh.ApiAddRecipeService.unPaiedList', {
      idcard,
      hosId,
      isXx
    });
    return code === '0' ? list : [];
  }

  /**
   * 已支付处方列表
   * @param idcard
   * @param orgid
   * @param hosid
   * @param idcardtype
   * @returns {Promise<void>}
   */
  async paied({idcard, orgid, hosid, idcardtype = '01'}) {
    const {code, list} = await this.$http('smarthos.yygh.ApiAddRecipeService.paiedList', {
      idcard,
      orgid,
      hosid,
      idcardtype
    });
    return code === '0' ? list : [];
  }


    /**
     * 同意续方
     * @param bizId
     * @param bizType
     * @param orderNos
     * @param bookHosId
     * @param compatId
     * @returns {Promise<boolean>}
     */
  async agree(bizId, bizType, orderNos, bookHosId, compatId) {
    const {code} = await this.$http('smarthos.recipe.order.his.add', {
        bizId, bizType, orderNos, bookHosId, compatId
    });
    return code === '0';
  }

  /**
   * 拒绝续方
   * @param id
   * @param cancelReason
   * @returns {Promise<boolean>}
   */
  async refuse(id, cancelReason) {
    const {code} = await this.$http('smarthos.continuation.prescription.refuse', {
      id, cancelReason
    });
    return code === '0';
  }


  handlerItem(data) {
    data._sex = sexFilter(data.commpatGender);
    data._replyType = RENEWAL_TYPE.find(r => r.id === data.replyType);
    data._replyTime = timeFormat(data.replyTime, '%Y/%m/%d %H:%M:%S');
    data._replyStatus = RENEWAL_ORDER_STATUS.find(r => r.id === data.replyStatus);
    if (data.historyRecipeOrder){
        data.historyRecipeOrder._hisCreateTime = timeFormat(data.historyRecipeOrder.createTime, '%Y/%m/%d');
        data.historyRecipeOrder._sex = sexFilter(data.commpatGender);
    }
    return data;
  }
}

export const renewalService = new RenewalService();
